"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwitchOption = exports.SwitchLabel = exports.SwitchInput = exports.SwitchButton = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var SwitchButton = _styledComponents.default.div.withConfig({
  componentId: "sc-1ig0aza-0"
})(["display:flex;align-items:center;margin:0 auto;", ""], function (_ref) {
  var appearance = _ref.appearance,
      theme = _ref.theme;
  return "\n    font-family: '".concat(theme.fonts.default, "', sans-serif;\n    font-weight: ").concat(appearance.label.fontWeight, ";\n    font-size: ").concat(appearance.label.fontSize, "px;\n    line-height: ").concat(appearance.label.lineHeight, "px;\n    letter-spacing: ").concat(appearance.label.letterSpacing, "px;\n  ");
});

exports.SwitchButton = SwitchButton;

var SwitchOption = _styledComponents.default.label.withConfig({
  componentId: "sc-1ig0aza-1"
})(["cursor:default;color:", ";&.switch-option-before{margin-right:16px;}&.switch-option-after{margin-left:16px;}"], function (_ref2) {
  var active = _ref2.active;
  return active ? _tokens.colors.neutral900 : _tokens.colors.neutral500;
});

exports.SwitchOption = SwitchOption;

var SwitchLabel = _styledComponents.default.label.withConfig({
  componentId: "sc-1ig0aza-2"
})([""]);

exports.SwitchLabel = SwitchLabel;

var SwitchInput = _styledComponents.default.input.withConfig({
  componentId: "sc-1ig0aza-3"
})(["position:absolute;margin-left:-9999px;visibility:hidden;", ""], function (_ref3) {
  var appearance = _ref3.appearance,
      color = _ref3.color,
      theme = _ref3.theme;
  return "\n    & + label {\n      display: block;\n      position: relative;\n      cursor: pointer;\n      outline: none;\n      user-select: none;\n      padding: 2px;\n      width: ".concat(appearance.switch.width, "px;\n      height: ").concat(appearance.switch.height, "px;\n      background-color: ").concat(_tokens.colors[color.color + color.scale], ";\n      border-radius: ").concat(appearance.borderRadius, ";\n      transition: all 0.4s;\n\n      &:before,\n      &:after {\n        display: block;\n        position: absolute;\n        content: '';\n      }\n\n      &:before {\n        top: 2px;\n        left: 2px;\n        bottom: 2px;\n        right: 2px;\n        background-color: ").concat(_tokens.colors.neutral0, ";\n        border-radius: 50vh;\n        transition: all 0.4s;\n      }\n\n      &:after {\n        top: ").concat(appearance.circle.margin.top, "px;\n        left: ").concat(appearance.circle.margin.top, "px;\n        bottom: ").concat(appearance.circle.margin.top, "px;\n        height: ").concat(appearance.circle.size.height, "px;\n        width: ").concat(appearance.circle.size.width, "px;\n        display: block;\n        background-color: ").concat(_tokens.colors[color.color + color.scale], ";\n        border-radius: 50vh;\n        transition: all 0.4s;\n        overflow: hidden;\n      }\n    }\n\n    &:checked + label {\n      background-color: ").concat(_tokens.colors[theme.colors.primary.color + theme.colors.primary.scale], ";\n\n      &:after {\n        left: ").concat(appearance.switch.width / 2 + 2, "px;\n        background-color: ").concat(_tokens.colors[theme.colors.primary.color + theme.colors.primary.scale], ";\n      }\n    }\n\n    &:disabled + label {\n      background-color: ").concat(_tokens.colors.neutral300, ";\n\n      &:after {\n        background-color: ").concat(_tokens.colors.neutral300, ";\n      }\n    }\n\n    &:hover{\n      & + label {\n        &:after {\n          opacity: 0.8;\n        }\n      }\n\n    }\n ");
});

exports.SwitchInput = SwitchInput;